import React, { useRef, useState, Fragment } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import Button from '../../../../Button';
import UploadIcon from '../../../../../icons/UploadIcon';
import useAssetImageUpoad from '../../../../../../hooks/useAssetImageUpload';

const propTypes = {
  className: PropTypes.string,
  element: PropTypes.shape({
    id: PropTypes.string.isRequired,
  }).isRequired,
  onElementConfigurationChange: PropTypes.func.isRequired,
};

const CardDesignerCardElementPhotoControls = ({
  className,
  element,
  onElementConfigurationChange,
}) => {
  const fileInputRef = useRef();
  const [saving, setSaving] = useState(false);
  const { cardElementConfiguration } = element;
  const { asset_image: assetImage } = cardElementConfiguration ?? {};
  const { uploading, onUpload, onUploadReset } = useAssetImageUpoad({
    onImageUploaded: async uploadedAssetImage => {
      setSaving(true);
      try {
        onElementConfigurationChange({
          element,
          config: {
            is_editable: false,
          },
          elementConfig: {
            asset_image_id: uploadedAssetImage.id,
          },
        });
      } catch {
        // Do nothing.
      } finally {
        setSaving(false);
      }
    },
  });

  const classes = classNames({
    'card-designer-card-element-controls': true,
    'card-designer-card-element-photo-controls': true,
    [className]: !!className,
  });

  // No extra controls on the photo slot element
  return (
    <div className={classes}>
      <input
        id="circle-asset-image"
        type="file"
        accept="image/*"
        onChange={event => {
          const [file] = event.target.files;
          onUpload(file);
        }}
        ref={ref => {
          fileInputRef.current = ref;
        }}
        hidden
      />
      <Button
        btnSize="sm"
        btnStyle="info"
        className="text-primary text-sm text-bold"
        disabled={saving || uploading}
        onClick={async () => {
          if (assetImage) {
            await onUploadReset();
            await onElementConfigurationChange({
              element,
              config: {
                is_editable: true,
              },
              elementConfig: {
                asset_image_id: null,
              },
            });
          } else {
            fileInputRef.current?.click();
          }
        }}
      >
        {saving || uploading ? (
          <Fragment>Saving...</Fragment>
        ) : (
          <Fragment>
            {assetImage ? (
              <span className="mr-1">&times;</span>
            ) : (
              <UploadIcon size={12} color="#0d84fe" className="mr-1" />
            )}
            {assetImage ? 'Remove image' : 'Upload an image'}
          </Fragment>
        )}
      </Button>
    </div>
  );
};

CardDesignerCardElementPhotoControls.propTypes = propTypes;

export default CardDesignerCardElementPhotoControls;
